import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Dropdown, MenuProps } from 'antd';
import { LogoutOutlined, GlobalOutlined } from '@ant-design/icons';
import { RootState } from '../../../store/store';
import { logout } from '../../../store/services/authService';
import User from '../../../assets/images/avatar.png';
import { useTranslation } from 'react-i18next';

const UserDropdown = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.auth.user);

  const capitalizeFirstLetter = (str: string | undefined): string => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login', { replace: true });
  };

  const handleLanguageChange = (lang: string) => {
    i18n.changeLanguage(lang);
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
    window.location.reload();
  };

  const menuItems: MenuProps['items'] = [
    {
      key: 'language',
      label: t('header.language'),
      icon: <GlobalOutlined />,
      children: [
        {
          key: 'en',
          label: 'English',
          onClick: () => handleLanguageChange('en'),
        },
        {
          key: 'ar',
          label: 'العربية',
          onClick: () => handleLanguageChange('ar'),
        },
      ],
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      label: t('header.logout'),
      icon: <LogoutOutlined />,
      danger: true,
      onClick: handleLogout,
    },
  ];

  return (
    <Dropdown
      menu={{ items: menuItems }}
      trigger={['click']}
      placement="bottomRight"
      overlayStyle={{ minWidth: '200px' }}
    >
      <div
        className="flex cursor-pointer items-center gap-2 hover:opacity-80 transition-opacity"
        data-test="user-dropdown"
      >
        <img
          src={User}
          alt="avatar"
          className="h-12 w-12 rounded-full border-2 border-white border-opacity-20 object-cover object-center"
          data-test="user-dropdown-avatar"
        />
        <span className="pl-2 pr-[5px] text-sm">
          <h4
            className="font-medium text-[#090909]"
            data-test="user-dropdown-name"
          >
            {capitalizeFirstLetter(user?.adminData?.firstName)}{' '}
            {capitalizeFirstLetter(user?.adminData?.lastName)}
          </h4>
          <span className="text-[#777777]" data-test="user-dropdown-role">
            {user?.role?.name}
          </span>
        </span>
        <span>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.08754 4.83687C3.31535 4.60906 3.68469 4.60906 3.9125 4.83687L7.00002 7.92439L10.0875 4.83687C10.3154 4.60906 10.6847 4.60906 10.9125 4.83687C11.1403 5.06468 11.1403 5.43402 10.9125 5.66183L7.4125 9.16183C7.1847 9.38963 6.81535 9.38963 6.58754 9.16183L3.08754 5.66183C2.85974 5.43402 2.85974 5.06468 3.08754 4.83687Z"
              fill="#637381"
            />
          </svg>
        </span>
      </div>
    </Dropdown>
  );
};

export default UserDropdown;
